import axios from "axios";
import "../config";

export const obtenerTicketsCliente = async () => {
  const config = {
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
    },
  };
  return await axios
    .get(global.ruta + "/tickets/ticketsCliente", config)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const obtenerTicketsBusqueda = async (ticket, email) => {
  const config = {
    params: { ticket: ticket, email: email },
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
    },
  };

  return await axios
    .get(global.ruta + "/tickets/ticketsBusqueda", config)
    .then((response) => {
      return response.data.records;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const crearTicket = async (data, producto) => {
  const config = {
    params: {
      producto: producto,
    },
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
    },
    body: data,
  };

  return await axios
    .post(global.ruta + "/tickets/crearTicket", data, config)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
};

export const addImagen = async (nombre, imagen, idTicket) => {
  const config = {
    params: { nombre: nombre, ticket: idTicket },
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
    },
    body: imagen,
  };

  return await axios
    .post(global.ruta + "/tickets/addImagen", { imagen: imagen }, config)
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
    });
};

export const enviarMensaje = async (mensaje, idSalesforce, email, tienda) => {
  const config = {
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
    },
    body: mensaje,
  };

  return await axios
    .post(
      global.ruta + "/tickets/sendEmail",
      {
        ParentId: idSalesforce,
        TextBody: mensaje,
        FromAddress: email,
        FromName: tienda,
        Incoming: true,
      },
      config
    )
    .then((response) => {
      return response;
    })
    .catch((err) => {
      console.log(err);
      return err;
    });
};

export const getDescripcionPorNombre = async (texto) => {
  const config = {
    headers: {
      Authorization: `Bearer ${window.sessionStorage.getItem("token")}`,
    },
    params: {
      texto,
    },
  };

  return await axios
    .get(global.ruta + "/common/descripcion", config)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      console.log(err);
    });
};
